import { ResolveState } from '../../../common';
import { ErrorResult } from '../../../upgrade/models/error-result';
import { Logger } from '../../utils/logger';

/**
 * Updater for iif errors.
 */
export class IiFUpdaterUtil {
    /**
     * the update function.
     * @param fileData the file data.
     * @param error the error object.
     * @returns the updated file data.
     */
    public update(fileData: string, error: ErrorResult): string {
        if (!fileData) {
            Logger.error(`Cannot find file data`);
        }

        const result = this.regexFixer(fileData);

        error.resolved = ResolveState.Resolved;
        return result;
    }

    /**
     * the update function.
     * @param inputString the input file data string.
     * @returns the updated file data string.
     */
    private regexFixer(inputString): string {
        const regexPattern = /iif\s*\(\s*((?:[^,\r\n]+|\([^)]*\))*)(?:\s*,\s*((?:[^,\r\n]+|\([^)]*\))*))?(?:\s*,\s*((?:[^,\r\n]+|\([^)]*\))))?\s*\)/g;

        Logger.error(regexPattern.test(inputString).toString());

        const replacedCode = inputString.replace(regexPattern, (match, condition, valueIfTrue, valueIfFalse) => {
            Logger.log('match: ' + match);
            if (valueIfTrue === undefined && valueIfFalse === undefined) {
                Logger.log('added valueIfTrue and valueIfFalse');
                return `iif(${condition}, of(null), of(null))`;
            }
            if (valueIfFalse === undefined) {
                Logger.log('added valueIfFalse');
                return `iif(${condition}, ${valueIfTrue}, of(null))`;
            }

            Logger.log('no-op');
            return match;
        });

        return replacedCode;
    }
}
